import { render, staticRenderFns } from "./HeaderUK.vue?vue&type=template&id=c624c930&scoped=true&"
import script from "./HeaderUK.vue?vue&type=script&lang=js&"
export * from "./HeaderUK.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUK.vue?vue&type=style&index=0&id=c624c930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c624c930",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIPhoneNumber: require('/opt/build/repo/components/UI/PhoneNumber.vue').default,UIMenu: require('/opt/build/repo/components/UI/Menu.vue').default,CartBannerTop: require('/opt/build/repo/components/Cart/BannerTop.vue').default})
